import styled from "styled-components";


export const FlexContainer = styled.div<{ $flexDirection?: string }>`
  display: flex;
  flex-direction: ${(props) => props.$flexDirection && `${props.$flexDirection}`};
`;
